// types
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    pins: [],
    goToCoords: null,
    interactiveLayers: []
};

const mapSlice = createSlice({
    name: 'map',
    initialState,
    reducers: {
        addPin(state, action) {
            const newPins = state.pins;
            newPins.push(action.payload)
            state.pins = newPins;
        },
        removePin(state, action) {
            const newPins = [...state.pins]
            const idx = newPins.findIndex(p => {
                return p === action.payload
            })
            newPins.splice(idx, 1)
            state.pins = newPins;
        },
        resetInteractiveLayers(state, action) {
            state.interactiveLayers = [];
        },
        addInteractiveLayer(state, action) {
            const newLayers = state.interactiveLayers;
            const layer = action.payload;
            console.log('layer ', layer);
            const exists = newLayers.indexOf(layer) !== -1;
            if (exists) return;
            newLayers.push(layer);
            state.interactiveLayers = newLayers;
        },
        goToCoords(state, action) {
            state.goToCoords = action.payload;
        }
    },
});

export const { addPin, removePin, resetInteractiveLayers, addInteractiveLayer, goToCoords } = mapSlice.actions;
export default mapSlice.reducer;
